const gu = {
    "gui.menuBar.file": "ફાઇલ",
    "gui.menuBar.edit": "સંપાદિત કરો",
    "gui.menuBar.new": "નવું",
    "gui.menuBar.saveNow": "હવે સાચવો",
    "gui.menuBar.saveAsCopy": "નકલ તરીકે સાચવો",
    "gui.menuBar.remix": "રિમિક્સ",
    "gui.menuBar.languageSelector": "ભાષા પસંદગી",
    "gui.menuBar.tutorialsLibrary": "ટ્યુટોરિયલ્સ",
    "gui.menuBar.community": "ખુલ્લું સમુદાય",
    "gui.menuBar.wiki": "એજન્ટ ડાઉનલોડ કરો",
    "gui.menuBar.restoreSprite": "સ્પ્રાઇટ પુનઃસ્થાપિત કરો",
    "gui.menuBar.restoreSound": "અવાજ પુનઃસ્થાપિત કરો",
    "gui.menuBar.restoreCostume": "પોશાક પુનઃસ્થાપિત કરો",
    "gui.menuBar.restore": "પુનઃસ્થાપિત કરો",
    "gui.menuBar.turboModeOff": "ટર્બો મોડ બંધ કરો",
    "gui.menuBar.turboModeOn": "ટર્બો મોડ ચાલુ કરો",
    "gui.menuBar.noDeviceSelected": "કોઈ ઉપકરણ પસંદ નથી",
    "gui.menuBar.noConnection": "કનેક્શન નથી",
    "gui.menuBar.downloadToComputer": "કમ્પ્યુટર પર ડાઉનલોડ કરો",
    "gui.menuBar.checkUpdate": "અપડેટ તપાસો",
    "gui.menuBar.installDriver": "ડ્રાઇવર ઇન્સ્ટોલ કરો",
    "gui.menuBar.clearCacheAndRestart": "કેશ સાફ કરો અને ફરી શરૂ કરો",
    "gui.adblockModal.title": "વિજ્ઞાપન અવરોધક મળ્યું",
    "gui.adblockModal.body":
        "TIFStudio ને વિજ્ઞાપન અવરોધક દ્વારા અવરોધિત કરવામાં આવી રહ્યું છે. કૃપા કરીને TIFStudio માટે વિજ્ઞાપન અવરોધકને નિષ્ક્રિય કરો.",
    "gui.adblockModal.reload": "ફરી લોડ કરો",
    "gui.alerts.createsuccess": "નવું પ્રોજેક્ટ બનાવ્યું.",
    "gui.alerts.createcopysuccess": "પ્રોજેક્ટની નકલ સાચવાઈ.",
    "gui.alerts.createremixsuccess": "પ્રોજેક્ટ રિમિક્સ તરીકે સાચવાયું.",
    "gui.alerts.creating": "નવું બનાવી રહ્યું છે...",
    "gui.alerts.creatingCopy": "પ્રોજેક્ટની નકલ બનાવી રહ્યું છે...",
    "gui.alerts.creatingRemix": "પ્રોજેક્ટનો રિમિક્સ બનાવી રહ્યું છે...",
    "gui.alerts.downloading": "ડાઉનલોડ થઈ રહ્યું છે...",
    "gui.alerts.loading": "લોડ થઈ રહ્યું છે...",
    "gui.alerts.saving": "સાચવી રહ્યું છે...",
    "gui.alerts.savesuccess": "પ્રોજેક્ટ સાચવાયું.",
    "gui.alerts.savingError": "પ્રોજેક્ટ સાચવી શકાયું નથી.",
    "gui.alerts.cloudInfo":
        "કૃપા કરીને નોંધો, ક્લાઉડ વેરિયેબલ ફક્ત સંખ્યાઓને સમર્થન આપે છે, અક્ષરો કે પ્રતીકોને નહીં.",
    "gui.alerts.cloudVariableFull": "ક્લાઉડ વેરિયેબલ મર્યાદા સુધી પહોંચી ગયું.",
    "gui.alerts.importedSvgTitle": "અપલોડ કરેલ SVG ફાઇલમાં સમસ્યા",
    "gui.alerts.importedSvgMessage":
        "SVG ફાઇલ લોડ કરી શકાઈ નથી. શું આ માન્ય SVG ફાઇલ છે?",
    "gui.alerts.importedSvgReset": "ફરી પ્રયાસ કરો",
    "gui.alerts.importedSvgCancel": "રદ કરો",
    "gui.alerts.uploadError": "અપલોડમાં ભૂલ",
    "gui.alerts.uploadSuccess": "અપલોડ સફળ",
    "gui.gui.addExtension": "એક્સટેન્શન ઉમેરો",
    "gui.gui.code": "કોડ",
    "gui.gui.backdrops": "પૃષ્ઠભૂમિ",
    "gui.gui.costumes": "પોશાકો",
    "gui.gui.sounds": "અવાજો",
    "gui.gui.codeTab": "કોડ",
    "gui.gui.costumesTab": "પોશાકો",
    "gui.gui.backdropsTab": "પૃષ્ઠભૂમિ",
    "gui.gui.soundsTab": "અવાજો",
    "gui.gui.defaultProjectTitle": "TIFStudio Project",
    "gui.alerts.lostPeripheralConnection":
        "TIFStudio lost connection to {extensionName}.",
    "gui.connection.unavailable.installscratchlink":
        "Make sure you have TIFStudio Agent installed and running in your system tray",
    "gui.menuBar.turnOffCamera": "કૅમેરા બંધ કરો",
    "gui.menu-bar.realtimeMode": "સ્ક્રેચ",
    "gui.menu-bar.programMode": "પ્રોગ્રામ",
    "gui.hardwareConsole.send": "મોકલો",
    "gui.hardwareConsole.buadrate": "બૉડ રેટ",
    "gui.hardwareConsole.endOfLine": "લાઇનનો અંત",
    "gui.hardwareConsole.hexform": "હેક્સ ફોર્મ",
    "gui.hardwareConsole.autoScroll": "ઓટો સ્ક્રોલ",
    "gui.hardwareHeader.upload": "અપલોડ",
    "gui.stageHeader.codeStageSizeLarge": "મોટું સ્ટેજ",
    "gui.stageHeader.codeStageSizeSmall": "નાનું સ્ટેજ",
    "gui.stageHeader.hideStage": "સ્ટેજ છુપાવો",
    "gui.stageHeader.fullscreenControl": "પૂર્ણ સ્ક્રીન નિયંત્રણ",
    "gui.extensionLibrary.comingSoon": "જલ્દી આવી રહ્યું છે",
    "gui.extensionLibrary.requires": "જરૂરી છે",
    "gui.extensionLibrary.collaboration": "સહયોગથી",
    // Extension Library Metadata
    "gui.extensionLibrary.manufactor": "ઉત્પાદક",
    "gui.extensionLibrary.version": "આવૃત્તિ",
    "gui.extensionLibrary.author": "લેખક",
    "gui.extensionLibrary.programMode": "પ્રોગ્રામ મોડ",
    "gui.extensionLibrary.programLanguage": "પ્રોગ્રામ ભાષા",
    "gui.extensionLibrary.deviceLearnMore": "વધુ જાણો",
    "gui.extensionLibrary.extensionHelp": "મદદ",
    "gui.extensionLibrary.Processing": "પ્રોસેસિંગ થઈ રહ્યું છે...",
    "gui.extensionLibrary.loaded": "લોડ થયું",
    "gui.extensionLibrary.notLoaded": "લોડ નથી થયું",
    "gui.extensionLibrary.chooseAnExtension": "એક એક્સટેન્શન પસંદ કરો",
    "gui.library.filterPlaceholder": "શોધો",
    "gui.library.allTag": "બધું",
    "gui.library.readMore": "વધુ વાંચો",
    "gui.library.readLess": "ઓછું વાંચો",
    "gui.loader.message1": "સ્પ્રાઇટ બનાવી રહ્યું છે...",
    "gui.loader.message2": "અવાજો લોડ કરી રહ્યું છે...",
    "gui.loader.message3": "પોશાકો લોડ કરી રહ્યું છે...",
    "gui.loader.message4": "એક્સટેન્શન લોડ કરી રહ્યું છે...",
    "gui.loader.message5": "બ્લોક બનાવી રહ્યું છે...",
    "gui.loader.message6": "ગણતરી કરી રહ્યું છે...",
    "gui.loader.message7": "લોડ થઈ રહ્યું છે...",
    "gui.loader.message8": "તૈયાર કરી રહ્યું છે...",
    "gui.loader.headline": "પ્રોજેક્ટ લોડ થઈ રહ્યું છે",
    "gui.loader.creating": "પ્રોજેક્ટ બનાવી રહ્યું છે",
    "gui.spriteLibrary.chooseASprite": "એક સ્પ્રાઇટ પસંદ કરો",
    "gui.spriteLibrary.paintASprite": "પેઇન્ટ",
    "gui.spriteLibrary.uploadASprite": "સ્પ્રાઇટ અપલોડ કરો",
    "gui.spriteLibrary.surprise": "આશ્ચર્ય",
    "gui.soundLibrary.chooseASound": "એક અવાજ પસંદ કરો",
    "gui.soundLibrary.record": "રેકોર્ડ",
    "gui.soundLibrary.uploadASound": "અવાજ અપલોડ કરો",
    "gui.costumeLibrary.chooseACostume": "એક પોશાક પસંદ કરો",
    "gui.costumeLibrary.paintACostume": "પેઇન્ટ",
    "gui.costumeLibrary.uploadACostume": "પોશાક અપલોડ કરો",
    "gui.backdropLibrary.chooseABackdrop": "એક પૃષ્ઠભૂમિ પસંદ કરો",
    "gui.backdropLibrary.paintABackdrop": "પેઇન્ટ",
    "gui.backdropLibrary.uploadABackdrop": "પૃષ્ઠભૂમિ અપલોડ કરો",
    "gui.spriteSelector.addSpriteFromLibrary": "એક સ્પ્રાઇટ પસંદ કરો",
    "gui.spriteSelector.addSpriteFromPaint": "પેઇન્ટ",
    "gui.spriteSelector.addSpriteFromSurprise": "આશ્ચર્ય",
    "gui.spriteSelector.addSpriteFromFileUpload": "સ્પ્રાઇટ અપલોડ કરો",
    "gui.stageSelector.addBackdropFromLibrary": "એક પૃષ્ઠભૂમિ પસંદ કરો",
    "gui.stageSelector.addBackdropFromPaint": "પેઇન્ટ",
    "gui.stageSelector.addBackdropFromSurprise": "આશ્ચર્ય",
    "gui.stageSelector.addBackdropFromFileUpload": "પૃષ્ઠભૂમિ અપલોડ કરો",
    "gui.stageSelector.stage": "સ્ટેજ",
    "gui.stageSelector.backdrops": "પૃષ્ઠભૂમિ",
    "gui.spriteSelectorItem.contextMenuDuplicate": "નકલ બનાવો",
    "gui.spriteSelectorItem.contextMenuExport": "નિર્યાત કરો",
    "gui.spriteSelectorItem.contextMenuDelete": "કાઢી નાખો",
    "gui.spriteInfo.sprite": "સ્પ્રાઇટ",
    "gui.spriteInfo.size": "કદ",
    "gui.spriteInfo.show": "બતાવો",
    "gui.spriteInfo.changeSize": "કદ બદલો",
    "gui.spriteInfo.changeX": "X બદલો",
    "gui.spriteInfo.changeY": "Y બદલો",
    "gui.spriteInfo.direction": "દિશા",
    "gui.spriteInfo.changeDirection": "દિશા બદલો",
    "gui.spriteInfo.isVisible": "દેખાય છે",
    "gui.deviceLibrary.chooseADevice": "એક ઉપકરણ પસંદ કરો",
    "gui.deviceLibrary.deviceUrl": "ડિવાઇસ URL દાખલ કરો",
    "gui.deviceLibrary.arduinoTag": "આર્ડુઇનો",
    "gui.deviceLibrary.microbitTag": "માઇક્રોબિટ",
    "gui.deviceLibrary.esp32Tag": "ESP32",
    "gui.deviceLibrary.kitTag": "કિટ",
    "gui.deviceLibrary.shieldTag": "શીલ્ડ",
    "gui.playButton.play": "ચલાવો",
    "gui.playButton.stop": "બંધ કરો",
    "gui.gui.variableScopeOptionAllSprites": "બધા સ્પ્રાઇટ માટે",
    "gui.gui.variableScopeOptionSpriteOnly": "માત્ર આ સ્પ્રાઇટ માટે",
    "gui.gui.cloudVariableOption": "ક્લાઉડ વેરિયેબલ (સર્વર પર સાચવાયેલ)",
    "gui.gui.variablePromptDefaultValue": "મારું વેરિયેબલ",
    "gui.gui.listVariable": "યાદી બનાવો",
    "gui.gui.makeAVariable": "વેરિયેબલ બનાવો",
    "gui.gui.newVariable": "નવું વેરિયેબલ",
    "gui.soundEditor.sound": "અવાજ",
    "gui.soundEditor.play": "ચલાવો",
    "gui.soundEditor.stop": "બંધ કરો",
    "gui.soundEditor.copy": "નકલ",
    "gui.soundEditor.paste": "પેસ્ટ",
    "gui.soundEditor.copyToNew": "નવામાં નકલ કરો",
    "gui.soundEditor.delete": "કાઢી નાખો",
    "gui.soundEditor.save": "સાચવો",
    "gui.soundEditor.undo": "પાછું લાવો",
    "gui.soundEditor.redo": "ફરી કરો",
    "gui.soundEditor.faster": "ઝડપી",
    "gui.soundEditor.slower": "ધીમું",
    "gui.soundEditor.echo": "ગુંજ",
    "gui.soundEditor.robot": "રોબોટ",
    "gui.soundEditor.louder": "જોરદાર અવાજ",
    "gui.soundEditor.softer": "નરમ અવાજ",
    "gui.soundEditor.reverse": "ઉલટું",
    "gui.soundEditor.fadeOut": "ફેડ આઉટ",
    "gui.soundEditor.fadeIn": "ફેડ ઇન",
    "gui.soundEditor.mute": "મ્યૂટ",
    "paint.paintEditor.hue": "રંગ",
    "paint.paintEditor.saturation": "સંતૃપ્તિ",
    "paint.paintEditor.brightness": "ચમક",
    "paint.paintEditor.fill": "ભરો",
    "paint.paintEditor.costume": "પોશાક",
    "paint.paintEditor.group": "સમૂહ",
    "paint.paintEditor.ungroup": "સમૂહ તોડો",
    "paint.paintEditor.undo": "પાછું લાવો",
    "paint.paintEditor.redo": "ફરી કરો",
    "paint.paintEditor.forward": "આગળ લાવો",
    "paint.paintEditor.backward": "પાછળ મોકલો",
    "paint.paintEditor.front": "સૌથી આગળ",
    "paint.paintEditor.back": "સૌથી પાછળ",
    "paint.paintEditor.more": "વધુ",
    "paint.modeTools.brushSize": "બ્રશનું કદ",
    "paint.modeTools.eraserSize": "ઇરેઝરનું કદ",
    "paint.modeTools.copy": "નકલ",
    "paint.modeTools.paste": "પેસ્ટ",
    "paint.modeTools.delete": "કાઢી નાખો",
    "paint.modeTools.curved": "વળાંકવાળું",
    "paint.modeTools.pointed": "નોકદાર",
    "paint.modeTools.thickness": "જાડાઈ",
    "paint.modeTools.flipHorizontal": "આડું પલટાવો",
    "paint.modeTools.flipVertical": "ઊભું પલટાવો",
    "paint.modeTools.filled": "ભરેલું",
    "paint.modeTools.outlined": "રૂપરેખા",
    "paint.paintEditor.bitmap": "બિટમેપમાં બદલો",
    "paint.paintEditor.vector": "વેક્ટરમાં બદલો",
    "paint.paintEditor.stroke": "રૂપરેખા",
    "paint.brushMode.brush": "બ્રશ",
    "paint.eraserMode.eraser": "ઇરેઝર",
    "paint.fillMode.fill": "ભરો",
    "paint.lineMode.line": "રેખા",
    "paint.ovalMode.oval": "ગોળ",
    "paint.rectMode.rect": "આયત",
    "paint.reshapeMode.reshape": "આકાર બદલો",
    "paint.roundedRectMode.roundedRect": "ગોળાકાર આયત",
    "paint.selectMode.select": "પસંદ કરો",
    "paint.textMode.text": "ટેક્સ્ટ",
    "paint.colorPicker.swap": "બદલો",
    "gui.uploadProgress.uploading": "અપલોડ થઈ રહ્યું છે",
    "gui.uploadProgress.uploadSuccess": "અપલોડ સફળ",
    "gui.uploadProgress.uploadError": "અપલોડમાં ભૂલ",
    "gui.uploadProgress.close": "બંધ કરો",
    "gui.uploadProgress.abort": "રદ કરો",
    "gui.connection.connect": "કનેક્ટ કરો",
    "gui.connection.disconnect": "ડિસ્કનેક્ટ કરો",
    "gui.connection.connected": "કનેક્ટેડ",
    "gui.connection.connecting": "કનેક્ટ થઈ રહ્યું છે...",
    "gui.connection.error": "ભૂલ",
    "gui.connection.unavailable": "ઉપલબ્ધ નથી",
    "gui.connection.noDevicesFound": "કોઈ ઉપકરણ મળ્યું નથી",
    "gui.connection.scanning": "સ્કેન કરી રહ્યું છે...",
    "gui.connection.help": "મદદ",
    "gui.connection.refresh": "તાજું કરો",
    "blockly.deleteBlock": "બ્લોક કાઢી નાખો",
    "blockly.duplicateBlock": "નકલ બનાવો",
    "blockly.addComment": "ટિપ્પણી ઉમેરો",
    "blockly.removeComment": "ટિપ્પણી કાઢો",
    "blockly.externalInput": "બાહ્ય ઇનપુટ",
    "blockly.inlineInput": "ઇનલાઇન ઇનપુટ",
    "blockly.disableBlock": "બ્લોક નિષ્ક્રિય કરો",
    "blockly.enableBlock": "બ્લોક સક્રિય કરો",
    "blockly.expandBlock": "બ્લોક વિસ્તૃત કરો",
    "blockly.collapseBlock": "બ્લોક સંકુચિત કરો",
    "blockly.help": "મદદ",
    "blockly.undo": "પાછું લાવો",
    "blockly.redo": "ફરી કરો",
    "blockly.cleanUp": "બ્લોક્સને સાફ કરો",
    "blockly.sortByCategory": "શ્રેણી અનુસાર ક્રમબદ્ધ કરો",
    "blockly.workspaceComment": "વર્કસ્પેસ ટિપ્પણી",
    "blockly.exportToHtml": "HTML તરીકે નિર્યાત કરો",
    "blockly.snapToGrid": "ગ્રીડ પર ચોંટાડો",
    "blockly.cannotDeleteVariable": "આ વેરિયેબલ કાઢી શકાતું નથી",
    "blockly.renameVariable": "વેરિયેબલનું નામ બદલો",
    "blockly.newVariable": "નવું વેરિયેબલ",
    "blockly.renameVariableTitle": 'બધા "%1" વેરિયેબલનું નામ બદલો:',
    "blockly.variableAlreadyExists": '"%1" નામનું વેરિયેબલ પહેલેથી છે',

    // Device translations
    "gui.device.unselectDevice.name": "ઉપકરણ અનસિલેક્ટ કરો",
    "gui.device.unselectDevice.description":
        "ઉપકરણને અનસિલેક્ટ કરો, શુદ્ધ રીઅલ-ટાઇમ પ્રોગ્રામિંગ મોડમાં પાછા ફરો.",
    "gui.device.connectingMessage": "કનેક્ટ થઈ રહ્યું છે",
    "gui.device.arduinoUno.description":
        "ઇલેક્ટ્રોનિક્સ અને કોડિંગ શીખવા માટે શ્રેષ્ઠ બોર્ડ.",
    "gui.device.arduinoNano.description":
        "Arduino Nano તમારા પ્રોજેક્ટ્સ બનાવવા માટે નાનું અને ક્લાસિક બોર્ડ છે.",
    "gui.device.arduinoLeonardo.description":
        "ક્લાસિક Arduino બોર્ડ જે માઉસ અથવા કીબોર્ડ તરીકે કામ કરી શકે છે.",
    "gui.device.arduinoMega2560.description":
        "54 ડિજિટલ પિન, 16 એનાલોગ ઇનપુટ અને 4 સીરિયલ પોર્ટ સાથેનું 8-બિટ બોર્ડ.",
    "gui.device.arduinoUnoR4Minima.description":
        "ઉચ્ચ પ્રદર્શન અને વધુ મેમરી, હાલના શીલ્ડ અને એક્સેસરીઝ સાથે સુસંગત.",
    "gui.device.arduinoUnoR4Wifi.description":
        "Wi-Fi અને Bluetooth સાથે, ઓન-બોર્ડ 12x8 LED મેટ્રિક્સ સાથે.",
    "gui.device.esp32.description":
        "Wi-Fi અને Bluetooth સાથે સમૃદ્ધ ફીચર્સવાળું બોર્ડ.",
    "gui.device.esp32S3.description":
        "AI એક્સેલરેટર અને શક્તિશાળી પેરિફેરલ્સ સાથે IoT અને AI માટે ઉચ્ચ-પ્રદર્શન બોર્ડ.",
    "gui.device.esp8266NodeMCU.description": "સસ્તું Wi-Fi SOC નિયંત્રણ બોર્ડ.",
    "gui.device.k210MaixDock.description":
        "K210 RISC-V ચિપ આધારિત બોર્ડ, મૂળભૂત કાર્યો સાથે બધા IO પિન ઉપલબ્ધ.",
    "gui.device.k210Maixduino.description": "ESP32 સાથે K210 RISC-V બોર્ડ.",
    "gui.device.raspberryPiPicoIconURL.description":
        "સરળ અને ઉપયોગી માઇક્રોકંટ્રોલર બોર્ડ.",
    "gui.device.raspberryPiPicoWIconURL.description":
        "2.4 GHz Wi-Fi અને Bluetooth 5.2 સાથેનું Pico.",
    "gui.device.raspberryPiPico2IconURL.description":
        "ઉચ્ચ-પ્રદર્શન ડ્યુઅલ-કોર MCU, વધુ RAM અને ફ્લેશ સાથે.",
    "gui.device.raspberryPiPico2WIconURL.description":
        "2.4 GHz Wi-Fi અને Bluetooth સાથેનું Pico 2.",
    "gui.device.microbit.description":
        "ડિજિટલ કૌશલ્ય શીખવા માટે પોકેટ-સાઇઝ કમ્પ્યુટર.",
    "gui.device.microbitV2.description":
        "ઉન્નત પ્રોસેસર, સ્પીકર, માઇક્રોફોન અને ટચ-સંવેદનશીલ લોગો.",
    "gui.device.makeymakey.description": "કોઈ પણ વસ્તુને કીમાં ફેરવો.",
    "gui.sharedMessages.sprite": "Tiffy",
    "gui.device.tifBot.description":
        "TIF-BOT એ ESP32-S3 આધારિત બોર્ડ છે જેમાં Wi-Fi, Bluetooth અને રોબોટિક્સ તેમજ IoT પ્રોજેક્ટ્સ માટે સમૃદ્ધ peripherals છે.",
    "gui.device.lightWingDrone.description":
        "લાઇટ વિંગ ડ્રોન એ એડવાન્સ્ડ સ્ટેબિલાઇઝેશન અને Wi-Fi કંટ્રોલ સાથેનું હાઇ-પર્ફોર્મન્સ ESP32-S3 આધારિત ફ્લાઇટ કંટ્રોલર છે.",
    "gui.device.roboticDog.description":
        "Robotic Dog એ Arduino Nano દ્વારા સંચાલિત એક સ્માર્ટ ચાર પગવાળો રોબોટ છે, જે જીવંત જેવી હિલચાલ અને અવરોધોને ટાળવાની ક્ષમતા ધરાવે છે.",
    "gui.device.roboticArm.description":
        "Robotic Arm એ Arduino Nano દ્વારા સંચાલિત એક મલ્ટી-એક્સિસ મેનિપ્યુલેટર છે, જે ચોક્કસ કાર્યો અને ઓટોમેશન લર્નિંગ માટે ડિઝાઇન કરવામાં આવ્યું છે.",
    // Music
    "music.categoryName": "સંગીત",
    "music.playDrumForBeats": "[DRUM] ડ્રમ [BEATS] બીટ્સ માટે વગાડો",
    "music.restForBeats": "[BEATS] બીટ્સ માટે થોભો",
    "music.playNoteForBeats": "[NOTE] નોટ [BEATS] બીટ્સ માટે વગાડો",
    "music.setInstrument": "વાદ્ય [INSTRUMENT] સેટ કરો",
    "music.changeTempo": "ટેમ્પો [TEMPO] થી બદલો",
    "music.setTempo": "ટેમ્પો [TEMPO] પર સેટ કરો",
    "music.getTempo": "ટેમ્પો",
    "music.drumBass": "(2) બાસ ડ્રમ",
    "music.drumBongo": "(13) બોન્ગો",
    "music.drumCabasa": "(15) કાબાસા",
    "music.drumClaves": "(9) ક્લેવ્સ",
    "music.drumClosedHiHat": "(6) બંધ હાઇ-હેટ",
    "music.drumConga": "(14) કોંગા",
    "music.drumCowbell": "(11) કાઉબેલ",
    "music.drumCrashCymbal": "(4) ક્રેશ સિમ્બલ",
    "music.drumCuica": "(18) કુઈકા",
    "music.drumGuiro": "(16) ગુઈરો",
    "music.drumHandClap": "(8) તાળી",
    "music.drumOpenHiHat": "(5) ખુલ્લી હાઇ-હેટ",
    "music.drumSideStick": "(3) સાઈડ સ્ટિક",
    "music.drumSnare": "(1) સ્નેર ડ્રમ",
    "music.drumTambourine": "(7) ખંજરી (Tambourine)",
    "music.drumTriangle": "(12) ટ્રાયંગલ",
    "music.drumVibraslap": "(17) વાઇબ્રાસ્લેપ",
    "music.drumWoodBlock": "(10) વુડ બ્લોક",
    "music.instrumentBass": "(6) બાસ",
    "music.instrumentBassoon": "(14) બાસૂન",
    "music.instrumentCello": "(8) સેલો",
    "music.instrumentChoir": "(15) ગાયકવૃંદ",
    "music.instrumentClarinet": "(10) ક્લેરનેટ",
    "music.instrumentElectricGuitar": "(5) ઇલેક્ટ్రિક ગિટાર",
    "music.instrumentElectricPiano": "(2) ઇલેક્ટ્રિક પિયાనో",
    "music.instrumentFlute": "(12) વાંસળી",
    "music.instrumentGuitar": "(4) ગિટાર",
    "music.instrumentMarimba": "(19) મેરિમ્બા",
    "music.instrumentMusicBox": "(17) મ્યુઝિક બોક્સ",
    "music.instrumentOrgan": "(3) ઓર્ગન",
    "music.instrumentPiano": "(1) પિયાનો",
    "music.instrumentPizzicato": "(7) પિઝિકાટો",
    "music.instrumentSaxophone": "(11) સેક્સોફોન",
    "music.instrumentSteelDrum": "(18) સ્ટીલ ડ્રમ",
    "music.instrumentSynthLead": "(20) સિન્થ લીડ",
    "music.instrumentSynthPad": "(21) સિન્થ પેડ",
    "music.instrumentTrombone": "(9) ટ્રોમ્બોન",
    "music.instrumentVibraphone": "(16) વાઇબ્રાફોન",
    "music.instrumentWoodenFlute": "(13) લાકડાની વાંસળી",

    // Pen
    "pen.categoryName": "પેન",
    "pen.clear": "બધું ભૂંસી નાખો",
    "pen.stamp": "સ્ટેમ્પ",
    "pen.penDown": "પેન નીચે",
    "pen.penUp": "પેન ઉપર",
    "pen.setColor": "પેનનો રંગ [COLOR] સેટ કરો",
    "pen.changeSize": "પેનનું કદ [SIZE] થી બદલો",
    "pen.setSize": "પેનનું કદ [SIZE] પર સેટ કરો",
    "pen.colorMenu.color": "રંગ",
    "pen.colorMenu.saturation": "સંતૃપ્તિ (saturation)",
    "pen.colorMenu.brightness": "તેજસ્વીતા (brightness)",
    "pen.colorMenu.transparency": "પારદર્શિતા",

    // Extension Library Names and Descriptions
    "gui.extension.music.name": "સંગીત",
    "gui.extension.music.description": "વાદ્યો અને ડ્રમ વગાડો.",
    "gui.extension.pen.name": "પેન",
    "gui.extension.pen.description": "તમારા સ્પ્રાઈટ્સ સાથે દોરો.",
    "gui.extension.videosensing.name": "વિડિઓ સેન્સિંગ",
    "gui.extension.videosensing.description": "કેમેરા સાથે ગતિ અનુભવો.",
    "gui.extension.poseface.name": "ફેસ સેન્સિંગ",
    "gui.extension.poseface.description": "કેમેરા સાથે ચહેરાની હિલચાલ અનુભવો.",
    "gui.extension.posehand.name": "હેન્ડ સેન્સિંગ",
    "gui.extension.posehand.description": "કેમેરા સાથે હાથની હિલચાલ અનુભવો.",
    "gui.extension.posebody.name": "બોડી પોઝ સેન્સિંગ",
    "gui.extension.posebody.description": "કેમેરા સાથે શરીરની હિલચાલ અનુભવો.",
    "gui.extension.teachablemachine.name": "ટીચેબલ મશીન",
    "gui.extension.teachablemachine.description":
        "તમારા કેમેરા સાથે કસ્ટમ મશીન લર્નિંગ મોડલ્સનો ઉપયોગ કરો.",
    "gui.extension.text2speech.name": "ટેક્સ્ટ ટુ સ્પીચ",
    "gui.extension.text2speech.description": "તમારા પ્રોજેક્ટ્સને બોલાવો.",
    "gui.extension.translate.name": "અનુવાદ",
    "gui.extension.translate.description": "ઘણી ભાષાઓમાં ટેક્સ્ટનો અનુવાદ કરો.",
    "gui.extension.makeymakey.name": "મેકી મેકી",
    "gui.extension.makeymakey.description": "કોઈપણ વસ્તુને ચાવી (Key) બનાવો.",

    // Arduino Translations
    "arduinoUno.category.pins": "પિન",
    "arduinoUno.category.serial": "સીરીયલ",
    "arduinoUno.category.data": "ડેટા",

    "arduinoNano.category.pins": "પિન",
    "arduinoNano.category.serial": "સીરીયલ",
    "arduinoNano.category.data": "ડેટા",

    "arduinoLeonardo.category.pins": "પિન",
    "arduinoLeonardo.category.serial": "સીરીયલ",
    "arduinoLeonardo.category.data": "ડેટા",

    "arduinoMega2560.category.pins": "પિન",
    "arduinoMega2560.category.serial": "સીરીયલ",
    "arduinoMega2560.category.data": "ડેટા",

    "arduinoEsp32.category.pins": "પિન",
    "arduinoEsp32.category.serial": "સીરીયલ",
    "arduinoEsp32.category.data": "ડેટા",

    "arduinoEsp8266.category.pins": "પિન",
    "arduinoEsp8266.category.serial": "સીરીયલ",
    "arduinoEsp8266.category.data": "ડેટા",

    "arduinoK210.category.pins": "પિન",
    "arduinoK210.category.serial": "સીરીયલ",
    "arduinoK210.category.data": "ડેટા",

    "arduinoRaspberryPiPico.category.pins": "પિન",
    "arduinoRaspberryPiPico.category.serial": "સીરીયલ",
    "arduinoRaspberryPiPico.category.data": "ડેટા",

    // Arduino Uno Blocks
    "arduinoUno.modeMenu.input": "ઇનપુટ",
    "arduinoUno.modeMenu.output": "આઉટપુટ",
    "arduinoUno.modeMenu.inputPullup": "ઇનપુટ-પુલઅપ",
    "arduinoUno.levelMenu.high": "હાઈ (High)",
    "arduinoUno.levelMenu.low": "લો (Low)",
    "arduinoUno.pins.setPinMode": "પિન [PIN] મોડ [MODE] સેટ કરો",
    "arduinoUno.pins.setDigitalOutput": "ડિજિટલ પિન [PIN] આઉટ [LEVEL] સેટ કરો",
    "arduinoUno.pins.setPwmOutput": "PWM પિન [PIN] આઉટ [OUT] સેટ કરો",
    "arduinoUno.pins.readDigitalPin": "ડિજિટલ પિન [PIN] વાંચો",
    "arduinoUno.pins.readAnalogPin": "એનાલોગ પિન [PIN] વાંચો",
    "arduinoUno.pins.setServoOutput": "સર્વો પિન [PIN] આઉટ [OUT] સેટ કરો",
    "arduinoUno.pins.attachInterrupt": "ઇન્ટરપ્ટ પિન [PIN] મોડ [MODE] જોડો",
    "arduinoUno.pins.detachInterrupt": "ઇન્ટરપ્ટ પિન [PIN] અલગ કરો",
    "arduinoUno.serial.serialBegin": "સીરીયલ શરૂ બાઉડરેટ [VALUE]",
    "arduinoUno.serial.serialPrint": "સીરીયલ પ્રિન્ટ [VALUE] [EOL]",
    "arduinoUno.serial.serialAvailable": "સીરીયલ ઉપલબ્ધ ડેટા લંબાઈ",
    "arduinoUno.serial.serialReadAByte": "સીરીયલ એક બાઈટ વાંચો",
    "arduinoUno.data.dataMap":
        "[DATA] ને ([ARG0], [ARG1]) થી ([ARG2], [ARG3]) માં મેપ કરો",

    // Arduino Nano Blocks
    "arduinoNano.modeMenu.input": "ઇનપુટ",
    "arduinoNano.modeMenu.output": "આઉટપુટ",
    "arduinoNano.modeMenu.inputPullup": "ઇનપુટ-પુલઅપ",
    "arduinoNano.levelMenu.high": "હાઈ (High)",
    "arduinoNano.levelMenu.low": "લો (Low)",
    "arduinoNano.pins.setPinMode": "પિન [PIN] મોડ [MODE] સેટ કરો",
    "arduinoNano.pins.setDigitalOutput": "ડિજિટલ પિન [PIN] આઉટ [LEVEL] સેટ કરો",
    "arduinoNano.pins.setPwmOutput": "PWM પિન [PIN] આઉટ [OUT] સેટ કરો",
    "arduinoNano.pins.readDigitalPin": "ડિજિટલ પિન [PIN] વાંચો",
    "arduinoNano.pins.readAnalogPin": "એનાલોગ પિન [PIN] વાંચો",
    "arduinoNano.pins.setServoOutput": "સર્વો પિન [PIN] આઉટ [OUT] સેટ કરો",
    "arduinoNano.pins.attachInterrupt": "ઇન્ટરપ્ટ પિન [PIN] મોડ [MODE] જોડો",
    "arduinoNano.pins.detachInterrupt": "ઇન્ટરપ્ટ પિન [PIN] અલગ કરો",
    "arduinoNano.serial.serialBegin": "સીરીયલ શરૂ બાઉડરેટ [VALUE]",
    "arduinoNano.serial.serialPrint": "સીરીયલ પ્રિન્ટ [VALUE] [EOL]",
    "arduinoNano.serial.serialAvailable": "સીરીયલ ઉપલબ્ધ ડેટા લંબાઈ",
    "arduinoNano.serial.serialReadAByte": "સીરીયલ એક બાઈટ વાંચો",
    "arduinoNano.data.dataMap":
        "[DATA] ને ([ARG0], [ARG1]) થી ([ARG2], [ARG3]) માં મેપ કરો",

    // Arduino Leonardo Blocks
    "arduinoLeonardo.modeMenu.input": "ઇનપુટ",
    "arduinoLeonardo.modeMenu.output": "આઉટપુટ",
    "arduinoLeonardo.modeMenu.inputPullup": "ઇનપુટ-પુલઅપ",
    "arduinoLeonardo.levelMenu.high": "હાઈ (High)",
    "arduinoLeonardo.levelMenu.low": "લો (Low)",
    "arduinoLeonardo.pins.setPinMode": "પિન [PIN] મોડ [MODE] સેટ કરો",
    "arduinoLeonardo.pins.setDigitalOutput":
        "ડિજિટલ પિન [PIN] આઉટ [LEVEL] સેટ કરો",
    "arduinoLeonardo.pins.setPwmOutput": "PWM પિન [PIN] આઉટ [OUT] સેટ કરો",
    "arduinoLeonardo.pins.readDigitalPin": "ડિજિટલ પિન [PIN] વાંચો",
    "arduinoLeonardo.pins.readAnalogPin": "એનાલોગ પિન [PIN] વાંચો",
    "arduinoLeonardo.pins.setServoOutput": "સર્વો પિન [PIN] આઉટ [OUT] સેટ કરો",
    "arduinoLeonardo.pins.attachInterrupt":
        "ઇન્ટરપ્ટ પિન [PIN] મોડ [MODE] જોડો",
    "arduinoLeonardo.pins.detachInterrupt": "ઇન્ટરપ્ટ પિન [PIN] અલગ કરો",
    "arduinoLeonardo.serial.serialBegin": "સીરીયલ શરૂ બાઉડરેટ [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "સીરીયલ પ્રિન્ટ [VALUE] [EOL]",
    "arduinoLeonardo.serial.serialAvailable": "સીરીયલ ઉપલબ્ધ ડેટા લંબાઈ",
    "arduinoLeonardo.serial.serialReadAByte": "સીરીયલ એક બાઈટ વાંચો",
    "arduinoLeonardo.data.dataMap":
        "[DATA] ને ([ARG0], [ARG1]) થી ([ARG2], [ARG3]) માં મેપ કરો",

    // Arduino Mega2560 Blocks
    "arduinoMega2560.modeMenu.input": "ઇનપુટ",
    "arduinoMega2560.modeMenu.output": "આઉટપુટ",
    "arduinoMega2560.modeMenu.inputPullup": "ઇનપુટ-પુલઅપ",
    "arduinoMega2560.levelMenu.high": "હાઈ (High)",
    "arduinoMega2560.levelMenu.low": "લો (Low)",
    "arduinoMega2560.pins.setPinMode": "પિન [PIN] મોડ [MODE] સેટ કરો",
    "arduinoMega2560.pins.setDigitalOutput":
        "ડિજિટલ પિન [PIN] આઉટ [LEVEL] સેટ કરો",
    "arduinoMega2560.pins.setPwmOutput": "PWM પિન [PIN] આઉટ [OUT] સેટ કરો",
    "arduinoMega2560.pins.readDigitalPin": "ડિજિટલ પિન [PIN] વાંચો",
    "arduinoMega2560.pins.readAnalogPin": "એનાલોગ પિન [PIN] વાંચો",
    "arduinoMega2560.pins.setServoOutput": "સર્વો પિન [PIN] આઉટ [OUT] સેટ કરો",
    "arduinoMega2560.pins.attachInterrupt":
        "ઇન્ટરપ્ટ પિન [PIN] મોડ [MODE] જોડો",
    "arduinoMega2560.pins.detachInterrupt": "ઇન્ટરપ્ટ પિન [PIN] અલગ કરો",
    "arduinoMega2560.serial.serialBegin": "સીરીયલ શરૂ બાઉડરેટ [VALUE]",
    "arduinoMega2560.serial.serialPrint": "સીરીયલ પ્રિન્ટ [VALUE] [EOL]",
    "arduinoMega2560.serial.serialAvailable": "સીરીયલ ઉપલબ્ધ ડેટા લંબાઈ",
    "arduinoMega2560.serial.serialReadAByte": "સીરીયલ એક બાઈટ વાંચો",
    "arduinoMega2560.data.dataMap":
        "[DATA] ને ([ARG0], [ARG1]) થી ([ARG2], [ARG3]) માં મેપ કરો",

    // Arduino ESP32 Blocks
    "arduinoEsp32.modeMenu.input": "ઇનપુટ",
    "arduinoEsp32.modeMenu.output": "આઉટપુટ",
    "arduinoEsp32.modeMenu.inputPullup": "ઇનપુટ-પુલઅપ",
    "arduinoEsp32.levelMenu.high": "હાઈ (High)",
    "arduinoEsp32.levelMenu.low": "લો (Low)",
    "arduinoEsp32.pins.setPinMode": "પિન [PIN] મોડ [MODE] સેટ કરો",
    "arduinoEsp32.pins.setDigitalOutput":
        "ડિજિટલ પિન [PIN] આઉટ [LEVEL] સેટ કરો",
    "arduinoEsp32.pins.setPwmOutput": "PWM પિન [PIN] આઉટ [OUT] સેટ કરો",
    "arduinoEsp32.pins.readDigitalPin": "ડિજિટલ પિન [PIN] વાંચો",
    "arduinoEsp32.pins.readAnalogPin": "એનાલોગ પિન [PIN] વાંચો",
    "arduinoEsp32.pins.setServoOutput": "સર્વો પિન [PIN] આઉટ [OUT] સેટ કરો",
    "arduinoEsp32.pins.attachInterrupt": "ઇન્ટરપ્ટ પિન [PIN] મોડ [MODE] જોડો",
    "arduinoEsp32.pins.detachInterrupt": "ઇન્ટરપ્ટ પિન [PIN] અલગ કરો",
    "arduinoEsp32.serial.serialBegin": "સીરીયલ શરૂ બાઉડરેટ [VALUE]",
    "arduinoEsp32.serial.serialPrint": "સીરીયલ પ્રિન્ટ [VALUE] [EOL]",
    "arduinoEsp32.serial.serialAvailable": "સીરીયલ ઉપલબ્ધ ડેટા લંબાઈ",
    "arduinoEsp32.serial.serialReadAByte": "સીરીયલ એક બાઈટ વાંચો",
    "arduinoEsp32.data.dataMap":
        "[DATA] ને ([ARG0], [ARG1]) થી ([ARG2], [ARG3]) માં મેપ કરો",

    // Arduino ESP8266 Blocks
    "arduinoEsp8266.modeMenu.input": "ઇનપુટ",
    "arduinoEsp8266.modeMenu.output": "આઉટપુટ",
    "arduinoEsp8266.modeMenu.inputPullup": "ઇનપુટ-પુલઅપ",
    "arduinoEsp8266.levelMenu.high": "હાઈ (High)",
    "arduinoEsp8266.levelMenu.low": "લો (Low)",
    "arduinoEsp8266.pins.setPinMode": "પિન [PIN] મોડ [MODE] સેટ કરો",
    "arduinoEsp8266.pins.setDigitalOutput":
        "ડિજિટલ પિન [PIN] આઉટ [LEVEL] સેટ કરો",
    "arduinoEsp8266.pins.setPwmOutput": "PWM પિન [PIN] આઉટ [OUT] સેટ કરો",
    "arduinoEsp8266.pins.readDigitalPin": "ડિજિટલ પિન [PIN] વાંચો",
    "arduinoEsp8266.pins.readAnalogPin": "એનાલોગ પિન [PIN] વાંચો",
    "arduinoEsp8266.pins.setServoOutput": "સર્વો પિન [PIN] આઉટ [OUT] સેટ કરો",
    "arduinoEsp8266.pins.attachInterrupt": "ઇન્ટરપ્ટ પિન [PIN] મોડ [MODE] જોડો",
    "arduinoEsp8266.pins.detachInterrupt": "ઇન્ટરપ્ટ પિન [PIN] અલગ કરો",
    "arduinoEsp8266.serial.serialBegin": "સીરીયલ શરૂ બાઉડરેટ [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "સીરીયલ પ્રિન્ટ [VALUE] [EOL]",
    "arduinoEsp8266.serial.serialAvailable": "સીરીયલ ઉપલબ્ધ ડેટા લંબાઈ",
    "arduinoEsp8266.serial.serialReadAByte": "સીરીયલ એક બાઈટ વાંચો",
    "arduinoEsp8266.data.dataMap":
        "[DATA] ને ([ARG0], [ARG1]) થી ([ARG2], [ARG3]) માં મેપ કરો",
    // Additional Data Blocks
    "arduinoUno.data.dataConstrain":
        "[DATA] ને ([ARG0], [ARG1]) વચ્ચે મર્યાદિત કરો",
    "arduinoUno.data.dataConvert": "[DATA] ને [TYPE] માં રૂપાંતરિત કરો",
    "arduinoUno.data.dataConvertASCIICharacter":
        "[DATA] ને ASCII અક્ષરમાં રૂપાંતરિત કરો",
    "arduinoUno.data.dataConvertASCIINumber":
        "[DATA] ને ASCII નંબરમાં રૂપાંતરિત કરો",
    "arduinoUno.dataTypeMenu.integer": "પૂર્ણાંક",
    "arduinoUno.dataTypeMenu.decimal": "દશાંશ",
    "arduinoUno.dataTypeMenu.string": "સ્ટ્રિંગ",

    "arduinoNano.data.dataConstrain":
        "[DATA] ને ([ARG0], [ARG1]) વચ્ચે મર્યાદિત કરો",
    "arduinoNano.data.dataConvert": "[DATA] ને [TYPE] માં રૂપાંતરિત કરો",
    "arduinoNano.data.dataConvertASCIICharacter":
        "[DATA] ને ASCII અક્ષરમાં રૂપાંતરિત કરો",
    "arduinoNano.data.dataConvertASCIINumber":
        "[DATA] ને ASCII નંબરમાં રૂપાંતરિત કરો",
    "arduinoNano.dataTypeMenu.integer": "પૂર્ણાંક",
    "arduinoNano.dataTypeMenu.decimal": "દશાંશ",
    "arduinoNano.dataTypeMenu.string": "સ્ટ્રિંગ",

    "arduinoLeonardo.data.dataConstrain":
        "[DATA] ને ([ARG0], [ARG1]) વચ્ચે મર્યાદિત કરો",
    "arduinoLeonardo.data.dataConvert": "[DATA] ને [TYPE] માં રૂપાંતરિત કરો",
    "arduinoLeonardo.data.dataConvertASCIICharacter":
        "[DATA] ને ASCII અક્ષરમાં રૂપાંતરિત કરો",
    "arduinoLeonardo.data.dataConvertASCIINumber":
        "[DATA] ને ASCII નંબરમાં રૂપાંતરિત કરો",
    "arduinoLeonardo.dataTypeMenu.integer": "પૂર્ણાંક",
    "arduinoLeonardo.dataTypeMenu.decimal": "દશાંશ",
    "arduinoLeonardo.dataTypeMenu.string": "સ્ટ્રિંગ",

    "arduinoMega2560.data.dataConstrain":
        "[DATA] ને ([ARG0], [ARG1]) વચ્ચે મર્યાદિત કરો",
    "arduinoMega2560.data.dataConvert": "[DATA] ને [TYPE] માં રૂપાંતરિત કરો",
    "arduinoMega2560.data.dataConvertASCIICharacter":
        "[DATA] ને ASCII અક્ષરમાં રૂપાંતરિત કરો",
    "arduinoMega2560.data.dataConvertASCIINumber":
        "[DATA] ને ASCII નંબરમાં રૂપાંતરિત કરો",
    "arduinoMega2560.dataTypeMenu.integer": "પૂર્ણાંક",
    "arduinoMega2560.dataTypeMenu.decimal": "દશાંશ",
    "arduinoMega2560.dataTypeMenu.string": "સ્ટ્રિંગ",

    "arduinoEsp32.data.dataConstrain":
        "[DATA] ને ([ARG0], [ARG1]) વચ્ચે મર્યાદિત કરો",
    "arduinoEsp32.data.dataConvert": "[DATA] ને [TYPE] માં રૂપાંતરિત કરો",
    "arduinoEsp32.data.dataConvertASCIICharacter":
        "[DATA] ને ASCII અક્ષરમાં રૂપાંતરિત કરો",
    "arduinoEsp32.data.dataConvertASCIINumber":
        "[DATA] ને ASCII નંબરમાં રૂપાંતરિત કરો",
    "arduinoEsp32.dataTypeMenu.integer": "પૂર્ણાંક",
    "arduinoEsp32.dataTypeMenu.decimal": "દશાંશ",
    "arduinoEsp32.dataTypeMenu.string": "સ્ટ્રિંગ",

    "arduinoEsp8266.data.dataConstrain":
        "[DATA] ને ([ARG0], [ARG1]) વચ્ચે મર્યાદિત કરો",
    "arduinoEsp8266.data.dataConvert": "[DATA] ને [TYPE] માં રૂપાંતરિત કરો",
    "arduinoEsp8266.data.dataConvertASCIICharacter":
        "[DATA] ને ASCII અક્ષરમાં રૂપાંતરિત કરો",
    "arduinoEsp8266.data.dataConvertASCIINumber":
        "[DATA] ને ASCII નંબરમાં રૂપાંતરિત કરો",
    "arduinoEsp8266.dataTypeMenu.integer": "પૂર્ણાંક",
    "arduinoEsp8266.dataTypeMenu.decimal": "દશાંશ",
    "arduinoEsp8266.dataTypeMenu.string": "સ્ટ્રિંગ",
    // Library manager & Board manager
    "gui.librariesBoardsTab": "લાઇબ્રેરીઓ",
    "gui.boardManagerTab": "બોર્ડ મેનેજર",
    
    "gui.boardManager.title": "બોર્ડ મેનેજર",
    "gui.boardManager.description":
        "ઔદ્યોગિક Arduino બોર્ડ શોધો અને ઇન્સ્ટોલ કરો.",
    "gui.boardManager.searchPlaceholder": "Arduino બોર્ડ શોધો (ઉદાહરણ: esp32)",
    "gui.boardManager.search": "શોધો",
    "gui.boardManager.searching": "શોધી રહ્યા છીએ...",
    "gui.boardManager.advancedOptionsShow":
        "▶ અદ્યતન વિકલ્પો (કસ્ટમ ઇન્સ્ટોલ પાથ)",
    "gui.boardManager.advancedOptionsHide": "▼ અદ્યતન વિકલ્પો છુપાવો",
    "gui.boardManager.recommended": "ભલામણ કરેલ",
    "gui.boardManager.installed": "ઇન્સ્ટોલ કરેલ ({count})",
    "gui.boardManager.searchResults": "શોધ પરિણામ {count}",
    "gui.boardManager.refresh": "↻ રિફ્રેશ",
    "gui.boardManager.refreshing": "↻ રિફ્રેશ થઈ રહ્યું છે...",

    "gui.libraryManager.title": "લાઇબ્રેરી મેનેજર",
    "gui.libraryManager.description":
        "ઔદ્યોગિક Arduino લાઇબ્રેરી શોધો અને ઇન્સ્ટોલ કરો.",
    "gui.libraryManager.searchPlaceholder":
        "Arduino લાઇબ્રેરી શોધો (ઉદાહરણ: Servo)",
    "gui.libraryManager.search": "શોધો",
    "gui.libraryManager.searching": "શોધી રહ્યા છીએ...",
    "gui.libraryManager.advancedOptionsShow":
        "▶ અદ્યતન વિકલ્પો (કસ્ટમ ઇન્સ્ટોલ પાથ)",
    "gui.libraryManager.advancedOptionsHide": "▼ અદ્યતન વિકલ્પો છુપાવો",
    "gui.libraryManager.recommended": "ભલામણ કરેલ",
    "gui.libraryManager.installed": "ઇન્સ્ટોલ કરેલ ({count})",
    "gui.libraryManager.searchResults": "શોધ પરિણામ {count}",
    "gui.libraryManager.refresh": "↻ રિફ્રેશ",
    "gui.libraryManager.refreshing": "↻ રિફ્રેશ થઈ રહ્યું છે...",
    "gui.gui.librariesBoardsTab": "લાઇબ્રેરીઓ",
    "gui.gui.boardsManagerTab": "બોર્ડ મેનેજર",
};

export default gu;
